/* eslint-disable react/jsx-boolean-value */
import { useCallback } from 'react';
import { CaretLeftOutlined, LeftOutlined, RightOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import classnames from 'classnames';
import './pagination.scss';
interface PaginationProps {
  page: number;
  totalPage: number;
  setPage: (page: number) => void;
  inSharing?: boolean;
}
const Pagination = (props: PaginationProps) => {
  const { page, totalPage, setPage, inSharing } = props;
  const pageIndication = `${page + 1}/${totalPage}`;
  const toPreviousPage = useCallback(() => {
    if (page > 0) {
      setPage(page - 1);
    }
  }, [page, setPage]);
  const toNextPage = useCallback(() => {
    if (page < totalPage - 1) {
      setPage(page + 1);
    }
  }, [page, totalPage, setPage]);
  return (
    <div className={classnames('pagination' /*, { 'in-sharing': inSharing }*/)}>
      {page !== 0 ? (
        <Button
          key="left"
          className="previous-page-button"
          icon={<LeftOutlined />}
          ghost={true}
          onClick={toPreviousPage}
        >
          {pageIndication}
        </Button>
      ) : (
        <div />
      )}
      {page + 1 < totalPage ? (
        <Button key="right" className="next-page-button" icon={<RightOutlined />} ghost={true} onClick={toNextPage}>
          {pageIndication}
        </Button>
      ) : (
        <div />
      )}
    </div>
  );
};

export default Pagination;
